import React from "react";
import { motion } from "framer-motion";
import { FaCheck, FaExclamationTriangle } from "react-icons/fa";

const DashboardCard = ({
  icon,
  title,
  subtitle,
  onClick,
  variant = "info",
  completed = false,
  index = 0
}) => {
  const variantStyles = {
    success: {
      border: "border-l-success-500",
      icon: "text-success-600",
      bg: "hover:bg-success-50",
    },
    danger: {
      border: "border-l-danger-500",
      icon: "text-danger-600",
      bg: "hover:bg-danger-50",
    },
    info: {
      border: "border-l-cyan-500",
      icon: "text-cyan-600",
      bg: "hover:bg-cyan-50",
    },
    secondary: {
      border: "border-l-purple-500",
      icon: "text-purple-600",
      bg: "hover:bg-purple-50",
    },
    primary: {
      border: "border-l-primary-500",
      icon: "text-primary-600",
      bg: "hover:bg-primary-50",
    }
  };

  const styles = variantStyles[variant] || variantStyles.info;

  const cardVariants = {
    hidden: { opacity: 0, y: 15 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.3,
        delay: index * 0.06,
        ease: "easeOut"
      }
    }
  };

  return (
    <motion.div
      variants={cardVariants}
      initial="hidden"
      animate="visible"
      whileHover={{ y: -3, transition: { duration: 0.2 } }}
      whileTap={{ scale: 0.97 }}
      onClick={onClick}
      className={`
        relative cursor-pointer rounded-xl p-4 h-full
        bg-white border-l-4 ${styles.border}
        shadow-sm hover:shadow-md ${styles.bg}
        transition-all duration-200
        flex items-center gap-3
      `}
    >
      {/* Icon */}
      <div className={`text-2xl ${styles.icon} flex-shrink-0`}>
        {icon}
      </div>

      {/* Content */}
      <div className="flex-1 min-w-0">
        <h3 className="text-sm font-bold text-neutral-800 leading-tight">
          {title}
        </h3>
        <p className="text-xs text-neutral-500 truncate">
          {subtitle}
        </p>
      </div>

      {/* Status badge */}
      <div className="flex-shrink-0">
        {completed ? (
          <span className="w-6 h-6 rounded-full bg-success-100 flex items-center justify-center">
            <FaCheck className="text-success-600 text-xs" />
          </span>
        ) : variant === "danger" ? (
          <span className="w-2.5 h-2.5 rounded-full bg-danger-500 animate-pulse" />
        ) : null}
      </div>
    </motion.div>
  );
};

export default DashboardCard;
